<style>
    .top-header-text {
        line-height: 1;
        font-size: 38;
        word-break: normal !important;
        font-weight: 400 !important;
    }

    @media (max-width: 640px) {
        .top-header-text {
            line-height: 1.2 !important;
            font-size: 24 !important;
            word-break: normal !important;
            font-weight: 400 !important;
        }
    }
</style>
<template>
<span>
    <v-card
          fluid
          elevation="0"
          class="mr-0 d-none d-lg-block"
          style=""
        >
          <v-container fluid class="container-side-padding" style="height: 96px !important; margin: 0px; padding-top: 26px; padding-bottom: 26px;">
            <v-row class="ma-0 pa-0" style="padding: 0px 0px 0px 0px !important;">
              <v-col cols="12" md="12" class="pa-0 ma-0">
                <v-lazy>
                  <v-container fluid class="pa-0 ma-0">
                  <v-tabs
                    v-model="main_nav_tab"
                    light
                    background-color="transparent"
                    class="pa-0 ma-0 diia-style-v-tabs-2"
                    active-class="diia-style-v-tabs-2-active"
                  >
                    <v-tab class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('org')">
                      Організації
                    </v-tab>
                    <v-tab class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('irs')">
                      Е-ресурси
                    </v-tab>
                    <v-tab class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('sub')">
                      Підсистеми
                    </v-tab>
                    <v-tab class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('websrv')">
                      Інтерфейси е-ресурсів
                    </v-tab>
                    <v-tab class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('srv')">
                      Сервіси
                    </v-tab>
                    <v-tab class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('itr')">
                      Взаємодії
                    </v-tab>
                    <v-tab v-if="authData" class="diia-style-v-tab-2" :ripple="false" @click="onClickTab('ss')">
                      Шлюзи безпечного обміну
                    </v-tab>
                  </v-tabs>
                  </v-container>
                </v-lazy>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <router-view></router-view>
    </span>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';

export default {
  name: "Catalog",
  components: {},
  data: () => ({
    main_nav_tab: "",
  }),

  updated: function () {
    this.env = this.$config.query_params.env;  
  },

  mounted: function () {
    document.title = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : 'Каталог системи Трембіта';
    this.setNavBar();
  },

  watch: {
      $route(to, from) {
          document.title = to.meta.title || 'Каталог системи Трембіта';

          this.setNavBar();

          if (to && to.query && from && from.query && to.query.env != from.query.env) {
            this.main_nav_tab = 0;
          }
      },
  },
  computed: {
    ...mapState(['authData']),
  },

  methods: {
    setNavBar() {
      if (this.$route.name == 'organizations-list' || this.$route.name == "organization-detail-info")
        this.main_nav_tab = 0;
      else if (this.$route.name == 'information-resources-list' || this.$route.name == "information-resource-detail-info")
        this.main_nav_tab = 1;
      else if (this.$route.name == 'subsystems-list' || this.$route.name == "subsystem-detail-info")
        this.main_nav_tab = 2;
      else if (this.$route.name == 'interfaces-list' || this.$route.name == "interface-detail-info")
        this.main_nav_tab = 3;
      else if (this.$route.name == 'services-list' || this.$route.name == "service-detail-info")
        this.main_nav_tab = 4;
      else if (this.$route.name == 'interactions-list' || this.$route.name == "interaction-detail-info")
        this.main_nav_tab = 5;
      else if (this.$route.name == 'servers-list' || this.$route.name == "server-detail-info")
        this.main_nav_tab = 6;
    },
    onClickTab(value) {
        if (value == 'org')
            this.$router.replace({name: 'organizations-list', query: this.$config.query_params});
        else if (value == 'irs')
            this.$router.replace({name: 'information-resources-list', query: this.$config.query_params});
        else if (value == 'sub')
            this.$router.replace({name: 'subsystems-list', query: this.$config.query_params});
        else if (value == 'websrv')
            this.$router.replace({name: 'interfaces-list', query: this.$config.query_params});
        else if (value == 'srv')
            this.$router.replace({name: 'services-list', query: this.$config.query_params});
        else if (value == 'itr')
            this.$router.replace({name: 'interactions-list', query: this.$config.query_params});
        else if (value == 'ss')
            this.$router.replace({name: 'servers-list', query: this.$config.query_params});
    },
  }
};
</script>
